var _g, _path, _g2, _path2, _g3, _g4, _path3, _g5, _path4, _path5, _path6, _path7, _g6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoStrategies = function SvgNoStrategies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#no-strategies_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__c)",
    fillOpacity: 0.86,
    d: "M40 79.762c22.091 0 40-17.802 40-39.762S62.091.238 40 .238 0 18.04 0 40s17.909 39.762 40 39.762Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__d)",
    fillOpacity: 0.1,
    d: "M40 79.762c22.091 0 40-17.802 40-39.762S62.091.238 40 .238 0 18.04 0 40s17.909 39.762 40 39.762Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#no-strategies_svg__e)",
    strokeOpacity: 0.25,
    strokeWidth: 0.989,
    d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__g)",
    fillOpacity: 0.86,
    d: "M40 70.476c16.932 0 30.659-13.645 30.659-30.476C70.659 23.168 56.932 9.523 40 9.523S9.341 23.168 9.341 40C9.341 56.83 23.068 70.476 40 70.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__h)",
    fillOpacity: 0.1,
    d: "M40 70.476c16.932 0 30.659-13.645 30.659-30.476C70.659 23.168 56.932 9.523 40 9.523S9.341 23.168 9.341 40C9.341 56.83 23.068 70.476 40 70.476Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#no-strategies_svg__i)",
    strokeOpacity: 0.25,
    strokeWidth: 0.758,
    d: "M40 70.305c16.837 0 30.487-13.568 30.487-30.305 0-16.737-13.65-30.305-30.487-30.305C23.163 9.695 9.514 23.263 9.514 40c0 16.737 13.649 30.305 30.486 30.305Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    fillOpacity: 0.13,
    d: "M26.485 18.343a.126.126 0 0 0-.09-.153l-1.094-.289a.126.126 0 0 0-.154.09.125.125 0 0 0 .09.152l.973.257-.26.968a.125.125 0 0 0 .09.152.126.126 0 0 0 .155-.088l.29-1.088Zm-7.97 7.908a.126.126 0 0 0 .154.089l1.095-.288a.125.125 0 1 0-.064-.242l-.974.256-.257-.968a.126.126 0 0 0-.244.064l.29 1.089Zm7.849-7.94-.064-.108c-3.216 1.856-5.894 4.746-7.772 7.953l.108.063.109.062c1.86-3.176 4.51-6.032 7.682-7.861l-.063-.109Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__l)",
    fillOpacity: 0.86,
    d: "M40 61.19c11.773 0 21.317-9.487 21.317-21.19 0-11.704-9.544-21.19-21.317-21.19S18.683 28.295 18.683 40c0 11.703 9.544 21.19 21.317 21.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__m)",
    fillOpacity: 0.1,
    d: "M40 61.19c11.773 0 21.317-9.487 21.317-21.19 0-11.704-9.544-21.19-21.317-21.19S18.683 28.295 18.683 40c0 11.703 9.544 21.19 21.317 21.19Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#no-strategies_svg__n)",
    strokeOpacity: 0.25,
    strokeWidth: 0.527,
    d: "M40 61.071c11.707 0 21.198-9.434 21.198-21.071 0-11.638-9.49-21.072-21.198-21.072-11.707 0-21.198 9.434-21.198 21.072 0 11.637 9.49 21.071 21.198 21.071Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__p)",
    fillOpacity: 0.86,
    d: "M40 51.666c6.482 0 11.737-5.223 11.737-11.666 0-6.444-5.255-11.667-11.737-11.667S28.264 33.556 28.264 40c0 6.443 5.254 11.666 11.736 11.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__q)",
    fillOpacity: 0.1,
    d: "M40 51.666c6.482 0 11.737-5.223 11.737-11.666 0-6.444-5.255-11.667-11.737-11.667S28.264 33.556 28.264 40c0 6.443 5.254 11.666 11.736 11.666Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#no-strategies_svg__r)",
    strokeOpacity: 0.25,
    strokeWidth: 0.527,
    d: "M40 51.547c6.416 0 11.617-5.17 11.617-11.547 0-6.378-5.201-11.548-11.617-11.548-6.416 0-11.617 5.17-11.617 11.548 0 6.377 5.201 11.547 11.617 11.547Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.07,
    strokeWidth: 0.527,
    d: "M40.12.238v79.524M20.104 5.505l40 68.87M5.419 20.016 74.7 59.778M0 39.88h80M5.3 59.778 74.58 20.016M19.896 74.375l40-68.87"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M40.12 19.286a.358.358 0 1 0 0-.714c-.198 0-.36.16-.36.356 0 .198.162.358.36.358ZM40.12 10c.198 0 .36-.16.36-.357a.358.358 0 0 0-.36-.357c-.198 0-.36.16-.36.357 0 .197.162.357.36.357ZM40.12.714c.198 0 .36-.16.36-.357A.358.358 0 0 0 40.12 0c-.198 0-.36.16-.36.357 0 .197.162.357.36.357ZM40.12 80c.198 0 .36-.16.36-.357a.358.358 0 0 0-.36-.357c-.198 0-.36.16-.36.357 0 .197.162.357.36.357ZM40.12 70.714c.198 0 .36-.16.36-.357a.358.358 0 0 0-.36-.358.358.358 0 1 0 0 .714ZM40.12 61.429a.358.358 0 1 0 0-.714c-.198 0-.36.16-.36.357 0 .197.162.357.36.357ZM19.401 39.88a.358.358 0 0 0-.36-.357.358.358 0 1 0 0 .714c.2 0 .36-.16.36-.356ZM10.06 39.88a.358.358 0 0 0-.36-.357.358.358 0 1 0 0 .714c.199 0 .36-.16.36-.356ZM.719 39.88a.358.358 0 0 0-.36-.357.358.358 0 1 0 0 .714c.199 0 .36-.16.36-.356ZM80 39.88a.358.358 0 0 0-.36-.357.358.358 0 1 0 0 .714c.199 0 .36-.16.36-.356ZM70.658 39.88a.358.358 0 0 0-.359-.357.358.358 0 1 0 0 .714c.199 0 .36-.16.36-.356ZM61.317 39.88a.358.358 0 0 0-.359-.357.358.358 0 1 0 0 .714c.199 0 .36-.16.36-.356Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__s)",
    fillOpacity: 0.44,
    d: "M34.376 29.758a11.762 11.762 0 0 0-4.432 4.224L5.389 20.238c1.557-3.452 8.264-11.786 14.85-14.643l14.137 24.163Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__u)",
    fillOpacity: 0.44,
    d: "M34.376 29.758a11.762 11.762 0 0 0-4.432 4.224L5.389 20.238c1.557-3.452 8.264-11.786 14.85-14.643l14.137 24.163Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    fillRule: "evenodd",
    d: "M20.065 22.363a.545.545 0 0 1-.04-.773l.256-.28a.17.17 0 0 1 .24-.013c.07.063.075.17.012.24l-.254.28a.207.207 0 0 0 .015.294l.375.337c.07.063.076.17.013.24a.17.17 0 0 1-.24.012l-.377-.337Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5FFDF",
    strokeLinecap: "round",
    strokeOpacity: 0.63,
    strokeWidth: 0.2,
    d: "m20.06 21.62.254-.28a.126.126 0 0 1 .177-.01.124.124 0 0 1 .009.176l-.255.28a.252.252 0 0 0 .018.358l.377.338c.05.046.055.124.008.175a.125.125 0 0 1-.176.01l-.377-.338a.5.5 0 0 1-.036-.71Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    fillRule: "evenodd",
    d: "M21.57 23.713a.552.552 0 0 0 .777-.04l.254-.28a.169.169 0 0 0-.012-.24.17.17 0 0 0-.24.013l-.255.28a.21.21 0 0 1-.296.015l-.376-.337a.171.171 0 0 0-.241.012.169.169 0 0 0 .012.24l.377.337Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5FFDF",
    strokeLinecap: "round",
    strokeOpacity: 0.63,
    strokeWidth: 0.2,
    d: "m22.313 23.643.255-.28a.124.124 0 0 0-.01-.176.125.125 0 0 0-.176.009l-.255.28a.256.256 0 0 1-.36.019l-.376-.338a.126.126 0 0 0-.176.01.123.123 0 0 0 .009.174l.376.338c.207.186.526.17.713-.036Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    fillRule: "evenodd",
    d: "M22.076 20.149a.553.553 0 0 0-.777.04l-.34.373a.168.168 0 0 0 .013.24.17.17 0 0 0 .24-.013l.34-.374a.21.21 0 0 1 .296-.014l.376.337a.17.17 0 1 0 .229-.252l-.377-.337Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5FFDF",
    strokeLinecap: "round",
    strokeOpacity: 0.63,
    strokeWidth: 0.2,
    d: "m21.333 20.218-.34.374a.124.124 0 0 0 .01.176c.05.046.13.042.176-.009l.34-.374a.255.255 0 0 1 .36-.018l.375.337c.052.046.131.042.177-.009a.124.124 0 0 0-.009-.175l-.376-.338a.507.507 0 0 0-.713.036Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    fillRule: "evenodd",
    d: "M23.58 21.498a.545.545 0 0 1 .04.774l-.34.373a.171.171 0 0 1-.24.012.169.169 0 0 1-.012-.239l.34-.374a.207.207 0 0 0-.016-.294l-.376-.337a.17.17 0 0 1-.012-.24.171.171 0 0 1 .24-.012l.376.337Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5FFDF",
    strokeLinecap: "round",
    strokeOpacity: 0.63,
    strokeWidth: 0.2,
    d: "m23.587 22.242-.34.373a.125.125 0 0 1-.177.009.123.123 0 0 1-.009-.175l.34-.374a.252.252 0 0 0-.018-.358l-.377-.338a.124.124 0 0 1-.008-.175.125.125 0 0 1 .176-.01l.376.338a.5.5 0 0 1 .037.71Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    d: "M21.545 22.323a.126.126 0 0 1-.134-.12l-.025-.502a.126.126 0 0 1 .12-.133l.506-.025c.07-.003.13.05.133.12l.026.502a.126.126 0 0 1-.12.133l-.506.025Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#B5FFDF",
    strokeOpacity: 0.63,
    strokeWidth: 0.2,
    d: "m21.457 22.202-.026-.503a.081.081 0 0 1 .077-.085l.506-.026a.081.081 0 0 1 .085.077l.026.503a.081.081 0 0 1-.077.085l-.506.025a.081.081 0 0 1-.085-.076Z",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__v)",
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8FFD5",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    d: "M21.134 20.88h-.38c-.21 0-.38.17-.38.378v.504M21.134 23.65h-.38a.379.379 0 0 1-.38-.378v-.503M22.148 20.88h.506c.21 0 .38.17.38.378v.504M22.148 23.65h.506c.21 0 .38-.169.38-.378v-.503"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8FFD5",
    d: "m21.583 21.788-.358.356a.125.125 0 0 0 0 .178l.358.357c.05.049.13.049.18 0l.358-.357a.125.125 0 0 0 0-.178l-.358-.356a.127.127 0 0 0-.18 0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__w)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__x)",
    d: "M42.158 41.136c0-1.168-.711-1.569-2.134-1.736-1.016-.133-1.22-.4-1.22-.867 0-.468.34-.768 1.017-.768.61 0 .949.2 1.118.7.034.101.136.168.237.168h.542a.23.23 0 0 0 .237-.234v-.033a1.683 1.683 0 0 0-1.525-1.369v-.8c0-.134-.1-.234-.27-.268h-.509c-.135 0-.237.1-.27.267v.768c-1.017.134-1.66.801-1.66 1.636 0 1.1.677 1.535 2.1 1.702.949.166 1.254.367 1.254.9 0 .535-.475.902-1.119.902-.88 0-1.185-.367-1.287-.868-.034-.133-.135-.2-.237-.2h-.576a.23.23 0 0 0-.237.233v.034c.136.834.677 1.435 1.795 1.602v.8c0 .135.102.234.271.268h.509c.135 0 .236-.1.27-.267v-.801c1.017-.167 1.694-.868 1.694-1.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.527,
    d: "m39.534 42.802-.102-.015c-.54-.08-.931-.265-1.202-.52-.267-.252-.426-.582-.491-.975v-.023c0-.066.047-.114.117-.114h.576c.04 0 .087.021.112.081l.009.03c.055.264.167.509.394.685.227.177.554.272 1.01.272.683 0 1.237-.397 1.237-1.02a.946.946 0 0 0-.073-.392.715.715 0 0 0-.248-.294c-.22-.155-.557-.25-1.032-.333h-.006l-.255-.035c-.573-.087-.99-.227-1.27-.442-.31-.24-.47-.585-.47-1.108 0-.762.586-1.39 1.556-1.517l.104-.014v-.857c.028-.125.093-.163.151-.163h.494c.128.028.165.093.166.148v.91l.11.01a1.564 1.564 0 0 1 1.415 1.263v.02c0 .067-.048.115-.118.115h-.542a.14.14 0 0 1-.105-.052l-.019-.034c-.09-.27-.232-.47-.444-.602-.208-.128-.471-.18-.787-.18-.355 0-.639.078-.836.234a.797.797 0 0 0-.3.653c0 .252.056.478.273.651.18.143.458.24.867.307l.184.028h.001c.708.083 1.214.222 1.543.469.318.239.485.591.485 1.148 0 .831-.622 1.492-1.593 1.651l-.1.017v.886c-.028.125-.093.163-.151.163H39.7c-.128-.027-.166-.092-.166-.147v-.904Z",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__y)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__z)",
    d: "M38.227 44.606c-2.642-.935-3.997-3.838-3.015-6.408.508-1.402 1.626-2.47 3.015-2.97.136-.068.203-.167.203-.335v-.467c0-.133-.067-.233-.203-.267-.034 0-.102 0-.135.034-3.218 1-4.98 4.372-3.964 7.543.61 1.868 2.066 3.304 3.964 3.904.135.067.27 0 .304-.133.034-.033.034-.067.034-.134v-.467c0-.1-.101-.233-.203-.3Zm3.591-10.413c-.135-.067-.271 0-.305.133-.033.033-.034.067-.034.134v.467c0 .134.102.267.204.334 2.642.934 3.997 3.838 3.015 6.408-.508 1.402-1.627 2.47-3.015 2.97-.136.067-.204.167-.204.334v.467c0 .134.068.234.204.267.033 0 .101 0 .135-.033 3.218-1.001 4.98-4.372 3.964-7.543-.61-1.902-2.1-3.337-3.964-3.938Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.527,
    d: "m41.818 34.193-.037.113c1.77.571 3.197 1.91 3.828 3.688l.059.173c.996 3.108-.73 6.412-3.886 7.394l-.027.008-.015.014a.03.03 0 0 1-.01.003l-.033.001a.136.136 0 0 1-.07-.046.166.166 0 0 1-.028-.1v-.468c0-.067.014-.11.033-.142a.238.238 0 0 1 .1-.083c1.416-.513 2.557-1.604 3.077-3.037 1.005-2.627-.376-5.593-3.07-6.556a.386.386 0 0 1-.096-.1.242.242 0 0 1-.044-.128v-.507l.002-.012.02-.02.008-.032a.09.09 0 0 1 .049-.063c.02-.009.049-.012.087.007l.053-.107Zm-3.606.086a.134.134 0 0 1 .071.047.166.166 0 0 1 .027.1v.468c0 .067-.013.11-.032.142a.238.238 0 0 1-.101.083c-1.416.513-2.556 1.604-3.077 3.037-1.004 2.627.376 5.592 3.07 6.556.034.024.07.06.1.1.03.046.04.08.04.094v.507l-.001.013-.02.02-.008.032a.09.09 0 0 1-.049.063c-.02.008-.049.012-.087-.007l-.008-.004-.009-.003-.173-.058a5.922 5.922 0 0 1-3.713-3.77c-.996-3.107.73-6.41 3.885-7.393l.029-.008.014-.015a.192.192 0 0 1 .042-.004Z",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__A)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__C)",
    d: "M42.158 41.136c0-1.168-.711-1.569-2.134-1.736-1.016-.133-1.22-.4-1.22-.867 0-.468.34-.768 1.017-.768.61 0 .949.2 1.118.7.034.101.136.168.237.168h.542a.23.23 0 0 0 .237-.234v-.033a1.683 1.683 0 0 0-1.525-1.369v-.8c0-.134-.1-.234-.27-.268h-.509c-.135 0-.237.1-.27.267v.768c-1.017.134-1.66.801-1.66 1.636 0 1.1.677 1.535 2.1 1.702.949.166 1.254.367 1.254.9 0 .535-.475.902-1.119.902-.88 0-1.185-.367-1.287-.868-.034-.133-.135-.2-.237-.2h-.576a.23.23 0 0 0-.237.233v.034c.136.834.677 1.435 1.795 1.602v.8c0 .135.102.234.271.268h.509c.135 0 .236-.1.27-.267v-.801c1.017-.167 1.694-.868 1.694-1.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#no-strategies_svg__D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-strategies_svg__E)",
    d: "M38.227 44.606c-2.642-.935-3.997-3.838-3.015-6.408.508-1.402 1.626-2.47 3.015-2.97.136-.068.203-.167.203-.335v-.467c0-.133-.067-.233-.203-.267-.034 0-.102 0-.135.034-3.218 1-4.98 4.372-3.964 7.543.61 1.868 2.066 3.304 3.964 3.904.135.067.27 0 .304-.133.034-.033.034-.067.034-.134v-.467c0-.1-.101-.233-.203-.3Zm3.591-10.413c-.135-.067-.271 0-.305.133-.033.033-.034.067-.034.134v.467c0 .134.102.267.204.334 2.642.934 3.997 3.838 3.015 6.408-.508 1.402-1.627 2.47-3.015 2.97-.136.067-.204.167-.204.334v.467c0 .134.068.234.204.267.033 0 .101 0 .135-.033 3.218-1.001 4.98-4.372 3.964-7.543-.61-1.902-2.1-3.337-3.964-3.938Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__c",
    x1: 40,
    x2: 40,
    y1: 0.238,
    y2: 79.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__e",
    x1: 40,
    x2: 40,
    y1: -0.226,
    y2: 80.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__g",
    x1: 40,
    x2: 40,
    y1: 9.523,
    y2: 70.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__i",
    x1: 40,
    x2: 40,
    y1: 9.524,
    y2: 70.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__l",
    x1: 40,
    x2: 40,
    y1: 18.809,
    y2: 61.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__n",
    x1: 40,
    x2: 40,
    y1: 18.809,
    y2: 61.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__p",
    x1: 40,
    x2: 40,
    y1: 28.333,
    y2: 51.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161616",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    stopOpacity: 0.28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__r",
    x1: 40,
    x2: 40,
    y1: 28.333,
    y2: 51.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__s",
    x1: 11.712,
    x2: 34.027,
    y1: 11.667,
    y2: 34.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DBF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5943",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__u",
    x1: 11.712,
    x2: 34.027,
    y1: 11.667,
    y2: 34.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DBF90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C5943",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__x",
    x1: 39.889,
    x2: 42.914,
    y1: 35.929,
    y2: 44.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__z",
    x1: 39.955,
    x2: 42.47,
    y1: 34.159,
    y2: 47.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__C",
    x1: 39.889,
    x2: 42.914,
    y1: 35.929,
    y2: 44.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-strategies_svg__E",
    x1: 39.955,
    x2: 42.47,
    y1: 34.159,
    y2: 47.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__b",
    width: 85.933,
    height: 85.457,
    x: -2.966,
    y: -2.728,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.966,
    dy: -2.966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.728
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.966,
    dy: 2.966
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.728
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_5510_49051",
    result: "effect2_innerShadow_5510_49051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__f",
    width: 65.865,
    height: 65.499,
    x: 7.068,
    y: 7.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.274,
    dy: -2.274
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.223
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.274,
    dy: 2.274
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.223
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_5510_49051",
    result: "effect2_innerShadow_5510_49051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__j",
    width: 23.668,
    height: 23.847,
    x: 10.521,
    y: 7.197,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.658824 0 0 0 0 1 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5510_49051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__k",
    width: 45.796,
    height: 45.542,
    x: 17.102,
    y: 17.228,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.581,
    dy: -1.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.581,
    dy: 1.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_5510_49051",
    result: "effect2_innerShadow_5510_49051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__o",
    width: 26.635,
    height: 26.495,
    x: 26.683,
    y: 26.752,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.581,
    dy: -1.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.581,
    dy: 1.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.717
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_innerShadow_5510_49051",
    result: "effect2_innerShadow_5510_49051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__t",
    width: 180.431,
    height: 179.832,
    x: -70.333,
    y: -70.127,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5510_49051",
    stdDeviation: 37.861
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__v",
    width: 11.01,
    height: 11.12,
    x: 16.2,
    y: 16.705,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5510_49051",
    stdDeviation: 1.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__w",
    width: 14.78,
    height: 18.285,
    x: 32.498,
    y: 31.598,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.488
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5510_49051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__y",
    width: 22.47,
    height: 21.789,
    x: 28.72,
    y: 29.829,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.488
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5510_49051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__A",
    width: 41.843,
    height: 41.163,
    x: 19.034,
    y: 19.352,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5510_49051",
    stdDeviation: 7.404
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__B",
    width: 14.493,
    height: 17.997,
    x: 32.642,
    y: 31.742,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.488
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5510_49051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "no-strategies_svg__D",
    width: 22.182,
    height: 21.502,
    x: 28.864,
    y: 29.972,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.488
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5510_49051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5510_49051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "no-strategies_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.204 33.719 -3.632) scale(117.269 117.952)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "no-strategies_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.204 25.255 7.147) scale(89.8833 90.4066)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "no-strategies_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.204 16.79 17.926) scale(62.4969 62.8607)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "no-strategies_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(83.204 8.11 28.982) scale(34.4084 34.6087)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "no-strategies_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v80H0z"
  })))));
};
export default SvgNoStrategies;